import { render, staticRenderFns } from "./tab-signatario.vue?vue&type=template&id=0668eb8f&"
import script from "./tab-signatario.vue?vue&type=script&lang=js&"
export * from "./tab-signatario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports